module.exports = __webpack_public_path__ + "img/ar_main_sec_pri.1193b275.svg";